import React from 'react';
import { useQuery } from '@apollo/client/react';
import { useParams } from 'react-router';
import { MainView } from '@repo/ui/Views';
import { useUser } from '@repo/hooks/useUser';
import { POLICIES } from '@/lib/Authorization';
import { FallbackCard } from '@repo/ui/Card';

import DidTabNav from '../components/DidTabNav';

import DIDS_SHOW_Q from '../gql/show.gql';

import DidOverview from '../components/DidOverview';

const Did = () => {
  const params = useParams();
  const didId = params.didId;
  const user = useUser();

  const { loading, data, error } = useQuery(DIDS_SHOW_Q, {
    variables: {
      id: String(didId),
    },
  });

  console.error(error);

  return (
    <MainView title={loading ? `Loading...` : `${data?.did?.number}`} loading={loading}>
      <DidTabNav />

      {POLICIES['dids:show'](user) ? (
        data?.did ? (
          <DidOverview did={data?.did} loading={loading} />
        ) : null
      ) : (
        <FallbackCard description="You do not have permissions to view number data." />
      )}
    </MainView>
  );
};

export default Did;
